module.exports = __webpack_public_path__ + "img/108.07186cbb.jpg";